import {REPORT_EARNED_QSB} from '/enum/records.enum';

export default {
  reportName: REPORT_EARNED_QSB,
};
